"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var defaultSize = 10;

var Flag = _styledComponents["default"].img.withConfig({
  displayName: "Flag",
  componentId: "sc-308ydm-0"
})(["height:", "px;margin:", ";width:", "px;&.is-in-dropdown,&.is-mobile{margin:", ";}&.is-mobile{height:", "px;width:", "px;}@media (min-width:600px){&.is-mobile{margin:", ";width:", "px;&.is-in-dropdown{height:", "px;margin:", ";width:", "px;}}}"], function (_ref) {
  var size = _ref.size;
  return size;
}, function (_ref2) {
  var isRtl = _ref2.isRtl;
  return isRtl ? "0 0 0 ".concat(defaultSize, "px") : "0 ".concat(defaultSize, "px 0 0");
}, function (_ref3) {
  var size = _ref3.size;
  return size;
}, function (_ref4) {
  var isRtl = _ref4.isRtl;
  return isRtl ? "0 0 0 ".concat(defaultSize / 2, "px") : "0 ".concat(defaultSize / 2, "px 0 0");
}, defaultSize * 2, defaultSize * 2, function (_ref5) {
  var isRtl = _ref5.isRtl;
  return isRtl ? "0 0 0 ".concat(defaultSize, "px") : "0 ".concat(defaultSize, "px 0 0");
}, defaultSize * 3, defaultSize * 2, function (_ref6) {
  var isRtl = _ref6.isRtl;
  return isRtl ? "0 0 0 ".concat(defaultSize, "px") : "0 ".concat(defaultSize, "px 0 0");
}, defaultSize * 2);

var _default = Flag;
exports["default"] = _default;